import React from 'react';
import getPacificTime from 'util/getPacificTime';

export function usePacificTime() {
  return React.useMemo(() => getPacificTime(), []);
}
